// BonBoZ: định dạng dùng chung của trang Thông báo đẩy: ngày giờ và cách viết
// số theo ngôn ngữ.
import { useI18n } from 'vue-i18n';
import { format, parseISO } from 'date-fns';

export const dateTime = iso =>
  iso ? format(parseISO(iso), 'dd/MM HH:mm') : '';

export const usePushReportFormat = () => {
  const { locale } = useI18n();

  const numberFormat = options => {
    try {
      return new Intl.NumberFormat(locale.value.replace('_', '-'), options);
    } catch {
      return new Intl.NumberFormat('en', options);
    }
  };

  const formatNumber = value => numberFormat().format(value || 0);

  return { formatNumber };
};
